// Based on https://codepen.io/knoland/pen/XKxAJb

var THREE = require('three');
var Signal = require('signals');

import StatsFPS from '../../helpers/Stats';
import * as dat from 'dat.gui';
import { TweenMax } from 'gsap';


var Bottles = function() {

    var aPaths = [
        [
            {x:0.0, z:930.0},
            {x:0.0, z:900.0},
            {x:0.0, z:870.0},
            // {x:0.0, z:860.0},
            {x:0.0, z:845.0},
            {x:0.0, z:800.0},
            {x:0.0, z:770.0},
            {x:0.0, z:730.0},
            {x:0.0, z:700.0},
            {x:0.0, z:660.0},
            {x:0.0, z:630.0},
            {x:0.0, z:590.0},
            {x:0.0, z:560.0},
            {x:0.0, z:535.0},
            {x:0.0, z:500.0},
            {x:0.0, z:460.0},
            {x:0.0, z:420.0},
            {x:0.0, z:380.0},
            {x:0.0, z:350.0},
            {x:0.0, z:320.0},
            {x:0.0, z:290.0},
            {x:0.0, z:260.0},
            {x:0.0, z:210.0},
            {x:0.0, z:165.0},
            {x:0.0, z:135.0},
            {x:0.0, z:100.0},
            {x:0.0, z:60.0},
            {x:0.0, z:35.0},
            {x:0.0, z:10.0},
            {x:0.0, z:-15.0},
            {x:0.0, z:-50.0},
            {x:0.0, z:-90.0},
            {x:0.0, z:-120.0},
            {x:0.0, z:-150.0},
            {x:0.0, z:-200.0},
            {x:0.0, z:-250.0},
            {x:0.0, z:-300.0},
            {x:0.0, z:-330.0},
            {x:0.0, z:-380.0},
            {x:0.0, z:-410.0},
            {x:0.0, z:-460.0},
            {x:0.0, z:-490.0},
            {x:0.0, z:-540.0},
            {x:0.0, z:-580.0},
            {x:0.0, z:-610.0},
            {x:0.0, z:-680.0},
            {x:0.0, z:-760.0},
            {x:0.0, z:-800.0},
            {x:0.0, z:-815.0},
            {x:0.0, z:-850.0},
            {x:0.0, z:-880.0},
            {x:0.0, z:-935.0},
        ]
    ];

    var camera, scene;
    var aBottles = [], aBottlesNear = [], aBottlesFar = [];
    var mousePcent = 0;
    var frm;
    var groupBottles;
    var bMove = false;
    // var aBottleMaterial = [];
    var aTextureBottle = [];
    var textureShadow;
    var zInd, idPath;
    var statsFPS = new StatsFPS();
    statsFPS.begin();

    var windowW, windowH;

    var boatZ, diffZ;

    var nBottleWidth = 10;


    var nSpeed0 = 0.36;
    var nSpeed1 = 0.45; //0.36;
    var nSpeed2 = 0.6; //0.46;
    var nSpeed3 = 0.9; //0.66;
    var nSpeed = nSpeed0;

    // Have the same in header.js
    var bMobile = window.innerWidth < 769
    var COEF_MOBILE = 1.7;
    if (bMobile) {
      nSpeed1 *= COEF_MOBILE;
      nSpeed2 *= COEF_MOBILE;
      nSpeed3 *= COEF_MOBILE;

      aPaths[0].push(
        {x:0.0, z:-980.0},
        {x:0.0, z:-1010.0},
        {x:0.0, z:-1050.0},
        {x:0.0, z:-1085.0},
        {x:0.0, z:-1120.0},
        {x:0.0, z:-1150.0},
        {x:0.0, z:-1190.0},
        {x:0.0, z:-1225.0},
        {x:0.0, z:-1250.0},
        {x:0.0, z:-1290.0},
        {x:0.0, z:-1330.0},
        {x:0.0, z:-1365.0},
        {x:0.0, z:-1400.0},
        {x:0.0, z:-1450.0},
        {x:0.0, z:-1485.0},
        {x:0.0, z:-1520.0},
        {x:0.0, z:-1550.0},
        {x:0.0, z:-1590.0},
        {x:0.0, z:-1625.0},
        {x:0.0, z:-1650.0},
        {x:0.0, z:-1690.0},
        {x:0.0, z:-1730.0},
        {x:0.0, z:-1765.0},
        {x:0.0, z:-1800.0},
        {x:0.0, z:-1830.0},
        {x:0.0, z:-1870.0},
        {x:0.0, z:-1900.0},
        {x:0.0, z:-1950.0},
        {x:0.0, z:-1985.0},
        {x:0.0, z:-2020.0},
        {x:0.0, z:-2050.0},
        {x:0.0, z:-2090.0},
        {x:0.0, z:-2125.0},
        {x:0.0, z:-2150.0},
        {x:0.0, z:-2190.0},
        {x:0.0, z:-2230.0},
        {x:0.0, z:-2265.0},
        {x:0.0, z:-2300.0},
        {x:0.0, z:-2330.0},
        {x:0.0, z:-2370.0},
        {x:0.0, z:-2399.0}
        // {x:0.0, z:-1930.0}
      )
    }

    var nSpeedX0 = 0.0;
    var nSpeedX1 = 0.4;
    var nSpeedX2 = 0.48;
    var nSpeedX3 = 0.60;
    var nSpeedX = nSpeedX0;

    var signal = new Signal.Signal();

    var create = function(_scene, _camera, _cbkCreated) {
        // console.log('Bottles::create()');

        camera = _camera;
        scene = _scene;

        nSpeed = nSpeed0;
        frm = 0;
        zInd = 990;

        aBottles = [];
        aBottlesNear = [];
        aBottlesFar = [];

        groupBottles = new THREE.Group();
        groupBottles.position.y = getYFromBreakpoints();
        groupBottles.rotation.x = getXRotationFromBreakpoints();
        scene.add(groupBottles);

        // var axis = new THREE.AxesHelper(100);
        // groupBottles.add(axis);

        textureShadow = new THREE.TextureLoader().load( `models/shadow.png` )

        var text1, text2, text3;

        var p = new Promise((resolve)=>{
            text1 = new THREE.TextureLoader().load( `models/bouee1.png`, ()=>{
                // console.log('TEXTURE 1 LOADED');
                resolve();
            });
        }).then(()=>{
            p = new Promise((resolve)=>{
                text2 = new THREE.TextureLoader().load( `models/bouee2.png`, ()=>{
                    // console.log('TEXTURE 2 LOADED');
                    resolve();
                });
            }).then(()=>{
                p = new Promise((resolve)=>{
                    text3 = new THREE.TextureLoader().load( `models/bouee3.png`, ()=>{
                        // console.log('TEXTURE 3 LOADED');
                        resolve();
                    });
                }).then(()=>{

                    // console.log('AFTER TEXTURE LOAD');
                    aTextureBottle.push(text1);
                    aTextureBottle.push(text2);
                    aTextureBottle.push(text3);

                    // Preparing alternative ways
                    aPaths[1] = [];
                    aPaths[2] = [];

                    // Randomize x
                    idPath = 0;
                    for(var i = 0; i < aPaths[0].length; i++) {
                        aBottlesNear.push(createBottle('path'));
                    }

                    // Based on path with decal -x
                    idPath = 0;
                    aPaths[1] = aPaths[0].slice(0);
                    for(var i = 0; i < aPaths[0].length; i++) {
                        aBottlesNear.push(createBottle('path2'));
                    }

                    // Based on path with decal +x
                    idPath = 0;
                    aPaths[2] = aPaths[0].slice(0);
                    for(var i = 0; i < aPaths[0].length; i++) {
                        aBottlesNear.push(createBottle('path3'));
                    }


                    // Center one bottle near
                    for(var i = 0; i < 1; i++) {
                        // aBottlesNear.push(createBottle('middle'));
                    }
                    // Around Center one set of bottle near
                    for(var i = 0; i < 3; i++) {
                        // aBottlesNear.push(createBottle('center'));
                    }
                    // Create one set of bottle near
                    for(var i = 0; i < 7; i++) {
                        // aBottlesNear.push(createBottle('near'));
                    }
                    // Create one set of bottle far
                    for(var i = 0; i < 10; i++) {
                        // aBottlesFar.push(createBottle('far'));
                    }

                    // createNums();
                    // positionNums();

                    // Remove near bottles overlapping
                    /*var bottle1, bottle2;
                    var bottleX, bottleZ;
                    for(var i = 0, nb = aBottlesNear.length; i < nb; i++) {
                        bottle1 = aBottlesNear[i];
                        for(var j = 0, nb = aBottlesNear.length; j < nb; j++) {
                            bottle2 = aBottlesNear[j];
                            if(i != j) {
                                bottleX = bottle1.position.x;
                                bottleZ = bottle1.position.z;
                                // if bottles are in a close z
                                if(bottleZ < bottle2.position.z + 8 && bottleZ > bottle2.position.z - 8) {
                                    // console.log(`check ${i} and ${j} : z(${bottleZ} and ${bottle2.position.z})  x(${bottleX} and ${bottle2.position.x})`);
                                    // if bottles are in a close x
                                    if(bottleX < bottle2.position.x + 8 && bottleX > bottle2.position.x - 8) {
                                        // Bottle overlapping
                                        // console.log(`bottles ${i} and ${j} are overlapping`);
                                        bottle2.visible = false;
                                    }
                                }
                            }
                        }
                    }*/

                    // Remove far bottles overlapping
                    /*for(var i = 0, nb = aBottlesFar.length; i < nb; i++) {
                        bottle1 = aBottlesFar[i];
                        for(var j = 0, nb = aBottlesFar.length; j < nb; j++) {
                            bottle2 = aBottlesFar[j];
                            if(i != j) {
                                bottleX = bottle1.position.x;
                                bottleZ = bottle1.position.z;
                                // if bottles are in a close z
                                if(bottleZ < bottle2.position.z + 8 && bottleZ > bottle2.position.z - 8) {
                                    // if bottles are in a close x
                                    if(bottleX < bottle2.position.x + 8 && bottleX > bottle2.position.x - 8) {
                                        // Bottle overlapping
                                        bottle2.visible = false;
                                    }
                                }
                            }
                        }
                    }*/

                    aBottles = aBottlesNear.concat(aBottlesFar);

                    _cbkCreated();
                });
            })
        });
        // initGUI();
    }

    var createBottle = function(type) {
        var rdm = Math.random();
        if(rdm < 2/8) rdm = 1; // Noir
        else if(rdm < 5/8) rdm = 2; // Bleu
        else rdm = 3; // Bleu

        var group = new THREE.Group();
        group.userData.catched = false;
        group.userData.bottleId = rdm;

        var mBottle = new THREE.MeshBasicMaterial( {
            map: aTextureBottle[rdm - 1]
            ,transparent: true
        } );
        mBottle.opacity = 0;

        var gBottle = new THREE.PlaneBufferGeometry(nBottleWidth, nBottleWidth);

        var mShadow = new THREE.MeshBasicMaterial( {
            // map: new THREE.TextureLoader().load( `models/shadow.png` )
            map: textureShadow
            ,transparent: true
        } );
        mShadow.opacity = 0;

        var plane = new THREE.Mesh(gBottle, mBottle);
        plane.position.y = 5;
        plane.position.z = 1;
        // plane.renderOrder = 10;

        var shadow = new THREE.Mesh(gBottle, mShadow);
        shadow.position.y = 5;
        shadow.position.z = 0;
        // plane.renderOrder = 0;

        group.add(shadow);
        group.add(plane);
        group.visible = false;
        groupBottles.add(group);

        var oPath = aPaths[0][idPath];
        if(type == 'path') {
            let nSpreadX = 250
            var rand = (Math.random() * nSpreadX) - (nSpreadX * 0.5);
            if(idPath == 0) {
                oPath.x = rand;
            } else {
                oPath.x = rand;
            }
            group.position.x = oPath.x;
            group.position.z = oPath.z - diffZ;
            // group.userData.initX = group.position.x;
            // group.userData.initZ = group.position.z - 200;// - 350;
            group.userData.appeared = false;
            idPath++;
        }
        //  Based on path, with a decal on x axe
        else if(type == 'path2') {
            let nSpreadX = 150
            var oPath2X = oPath.x - 50 - (Math.random() * nSpreadX);
            group.position.x = oPath2X;
            group.position.z = oPath.z - diffZ;
            // group.userData.initX = group.position.x;
            // group.userData.initZ = group.position.z - 200;// - 350;
            group.userData.appeared = false;
            idPath++;
        }
        //  Based on path, with a decal on x axe
        else if(type == 'path3') {
            let nSpreadX = 150
            var oPath3X = oPath.x + 50 + (Math.random() * nSpreadX);
            group.position.x = oPath3X;
            group.position.z = oPath.z - diffZ;
            // group.userData.initX = group.position.x;
            // group.userData.initZ = group.position.z - 200;// - 350;
            group.userData.appeared = false;
            idPath++;
        }
        /*
        else if(type == 'middle') {
            group.position.x = 0;
            // group.position.z = 900 + (Math.random() * 98);
            group.position.z = 936 + (Math.random() * 20);
            // group.userData.initX = group.position.x;
            // group.userData.initZ = group.position.z - 200;// - 350;
        }
        else if(type == 'center') {
            zInd += Math.random() * 3;
            group.position.x = (Math.random() - 0.5) * 50;// 1200;
            // group.position.z = 900 + (Math.random() * 98);
            group.position.z = zInd; //936 + ( 5 * aBottlesNear.length ); // z incrementation to prevent overlaps
            // group.userData.initX = group.position.x;
            // group.userData.initZ = group.position.z - 200;// - 350;
        }
        else if(type == 'near') {
            zInd += Math.random() * 6;
            group.position.x = (Math.random() - 0.5) * 720;// 1200;
            // group.position.z = 900 + (Math.random() * 98);
            group.position.z = zInd; //940 + (aBottlesNear.length * 2); // z incrementation to prevent overlaps
            // group.userData.initX = group.position.x;
            // group.userData.initZ = group.position.z - 200;// - 350;
        }
        else if(type == 'far') {
            zInd += Math.random() * 20;
            group.position.x = (Math.random() - 0.5) * 1600;// 1200;
            group.position.z = 760 + (Math.random() * 200);
            // group.userData.initX = group.position.x;
            // group.userData.initZ = group.position.z - 100;
        }
        */
        // group.position.y = -10.7;
        // group.position.y = 0;
        // group.position.y = getYFromBreakpoints();

        // console.log(`{x:${group.position.x}, z:${group.position.z}}`);

        return group;
    }

    /**
     * TODO: Find the equation instead of hard breakpoints
     */
    var getYFromBreakpoints = () => {
      if (windowH < 361) return -3;
      // if (windowH < 376) return 40
      // if (windowH < 641) return 40
      else if (windowH < 769) return -2;
      // if (windowH < 900) return 40
      // if (windowH <= 1080) return 40
      // if (windowH <= 1440 ) return 40
      // if (windowH <= 1600 ) return 40
      else return -1;
    }

    var getXRotationFromBreakpoints = () => {
      return 0.014;
      /* if (windowH < 361) return 0.045
      if (windowH < 376) return 0.045
      if (windowH < 641) return 0.045
      if (windowH < 769) return 0.045
      if (windowH < 900) return 0.045
      if (windowH <= 1080) return 0.045
      if (windowH <= 1440 ) return 0.045
      if (windowH <= 1600 ) return 0.045
      else return 0.045 */
    }

    var show = function() {
        return new Promise((resolve)=>{
            var group;
            // console.log(`Bottles::show()`, aBottles);
            for(var i = 0, nb = 3, l = aBottles.length; i < nb; i++) {
                group = aBottles[i];
                TweenMax.to(group.children[0].material, 0.3, {delay:0.5 * i, opacity:1});
                TweenMax.to(group.children[1].material, 0.3, {delay:0.5 * i, opacity:1, onComplete:(_i, _nb)=>{
                    if(_i == _nb - 1) {
                        bMove = true;
                        resolve();
                    }
                }, onCompleteParams:[i, nb]});
            }
        });
    }

    var FAREST_Z = 180 // 220 // 770
    var fpsCompensation = 1
    var move = function() {
        // console.log(`MOVE BOTTLES`);
        statsFPS.update();

        if (statsFPS.fps() > 60)
          fpsCompensation = (60 / statsFPS.fps());
        else
          fpsCompensation = 1
        // if (fpsCompensation > 5 ) fpsCompensation = 1; // This means the user changed tab, or loose focus
        // console.log(
        //   `FPS ${statsFPS.fps()}, compensation ${fpsCompensation}`
        // );
        // if(bMove)  {
            var group;
            for(var i = 0, nb = aBottles.length; i < nb; i++) {
                // Move the bottles
                group = aBottles[i];
                group.position.x -= mousePcent * nSpeedX * fpsCompensation; //0.4;
                group.position.y += (Math.sin(frm + i) * 0.013);
                group.position.z += nSpeed * fpsCompensation;
                group.rotation.z = Math.sin(frm + i) * 0.05;

                if(group.userData.appeared == false && group.position.z > FAREST_Z - diffZ) {
                    group.visible = true;
                    group.userData.appeared = true;
                    TweenMax.to(group.children[0].material, 2, {opacity:1});
                    TweenMax.to(group.children[1].material, 2, {opacity:1});
                }
                // Bottle has been catched, not put back to far Z
                else if(group.position.z > boatZ && group.visible && group.userData.catched == false && group.position.x > -10 && group.position.x < 10) {
                    group.userData.catched = true;
                    group.visible = false;
                    signal.dispatch('catched', group.userData.bottleId);
                }
                // Bottle is off screen, behind the boat, put back to far Z
                else if(group.visible && group.position.z > 1000) {
                    // dont reuse the bottles
                    group.visible = false;

                    // Reuse the bottles
                    // group.visible = true;
                    // group.children[0].material.opacity = 0.0;
                    // var rdm = Math.round(Math.random() * 2) + 1;
                    // group.children[1].material.map = aTextureBottle[rdm - 1];
                    // group.children[1].material.opacity = 0.0;
                    // TweenMax.to(group.children[0].material, 2, {opacity:1});
                    // TweenMax.to(group.children[1].material, 2, {opacity:1});
                    // group.userData.bottleId = rdm;
                    // group.position.x = group.userData.initX;
                    // group.position.z = group.userData.initZ;
                }
            }
            frm += 0.06;
        // }
    }

    function updateBoatZ(z) {
      windowW = window.innerWidth;
      windowH = document.documentElement.clientHeight; //window.innerHeight;

      if (windowH < 361) boatZ = z - 50;
      else if (windowH < 376) boatZ = z - 15;
      else if (windowH < 641) boatZ = z - 20;
      else if (windowH < 769) boatZ = z - 30;
      else if (windowH < 900) boatZ = z - 10;
      else boatZ = z - 10;
      diffZ = 990 - boatZ;
      // console.log(`updateBoatZ ${boatZ}`, `diffZ ${diffZ}`);
      if (groupBottles)
        groupBottles.position.y = getYFromBreakpoints();
    }

    function setWheelOrientation(pcent) {
        mousePcent = pcent;
        // mousePcent = 0;
    }

    function updateSpeed(type) {
        if(type == 'step0') {
            nSpeed = nSpeed0;
            nSpeedX = nSpeedX0;
        }
        else if(type == 'step1') {
            nSpeed = nSpeed1;
            nSpeedX = nSpeedX1;
        }
        else if(type =='step2') {
            nSpeed = nSpeed2;
            nSpeedX = nSpeedX2;
        }
        else if(type =='step3') {
            nSpeed = nSpeed3;
            nSpeedX = nSpeedX3;
        }
    }

    function removeAll() {
        // console.log('Bottles::removeAll()');
        bMove = false;
        var group;
        for(var i = 0, nb = aBottles.length; i < nb; i++) {
            group = aBottles[i];
            TweenMax.to(group.children[0].material, 0.5, {opacity:.0});
            TweenMax.to(group.children[1].material, 0.5, {opacity:.0, onComplete:(_i, _nb)=>{
                if(_i == _nb - 1) {
                    for(var j = 0; j < _nb; j++) {
                        group = aBottles[j];
                        groupBottles.remove(group);

                        group.children[0].material.dispose();
                        group.children[1].material.dispose();

                        group.children[0].geometry.dispose();
                        group.children[1].geometry.dispose();
                    }
                    aBottles = aBottlesFar = aBottlesNear = [];
                    // console.log('Bottles::removeAll() Done !');

                }
            }, onCompleteParams:[i, nb]});
        }
    }

    function initGUI() {
      // console.log(`!!!!!!!! INIT GUI BOTTLES !`);
        // dat gui
        if (!window.datGUI) {
          var gui = new dat.GUI();
          window.datGUI = gui;
        } else {
          var gui = window.datGUI
        }
        // var ambiantwheelDirectionGUI = wheelDirectionGUI.addFolder("ambiant");
        // ambiantwheelDirectionGUI.addColor(ambiantLightConfig, 'color').onChange(()=>{
            //     ambientLight.color = new THREE.Color( ambiantLightConfig.color );
            // });

        // var wheelDirectionGUI = gui.addFolder("BOTTLE");
        // wheelDirectionGUI.add(aBottles[0].position, 'x');
        // wheelDirectionGUI.add(aBottles[0].position, 'y');
        // wheelDirectionGUI.add(aBottles[0].position, 'z');
        // wheelDirectionGUI.open()

        var wheelDirectionGUI = gui.addFolder("BOTTLE POSITION");
        wheelDirectionGUI.add(groupBottles.position, 'x');
        wheelDirectionGUI.add(groupBottles.position, 'y');
        wheelDirectionGUI.add(groupBottles.position, 'z');
        wheelDirectionGUI.open();

        var wheelDirectionGUI = gui.addFolder("BOTTLE ROTATION");
        wheelDirectionGUI.add(groupBottles.rotation, 'x').step(0.001);
        wheelDirectionGUI.add(groupBottles.rotation, 'y').step(0.001);
        wheelDirectionGUI.add(groupBottles.rotation, 'z').step(0.001);
        wheelDirectionGUI.open();
    }

    return {
        create,
        show,
        removeAll,
        move,
        setWheelOrientation,
        updateSpeed,
        updateBoatZ,
        signal
    };
}
export {Bottles as default};
